<app-navbar></app-navbar>

<section class="min-h-[60dvh] bg-black text-white">
    <div class="w-full">
        <div class="min-h-[50dvh] bg-no-repeat bg-cover bg-bottom md:bg-fixed relative" style="background-image: url(/src/assets/img/about_us/bg-3.jpg);">
            <!-- Gradient overlay -->
            <div class="absolute -inset-2 bg-gradient-to-t from-black via-black/85 to-transparent"></div>
            <div class="relative text-neutral-content">
                <div class="pt-40 pb-20 max-w-4xl mx-auto tex p-8">
                    <div class="grid grid-cols-1 md:grid-cols-2 gap-4 items-center justify-center">
                        <div>
                            <img src="/assets/img/about_us/Tire-structure.webp" alt="" srcset="" class="w-full h-auto rounded-lg shadow-lg">
                        </div>
                        <div>
                            <h1 class="text-2xl md:text-4xl font-bold mb-6 uppercase ">
                                {{texts.title}}
                            </h1>
                            <p class="text-base text-gray-300 mb-4 leading-relaxed">
                                {{texts.subtitle[0]}}
                            </p>
                            <p class="text-base text-gray-300 mb-8">
                                {{texts.subtitle[1]}}
                            </p>
                            
                        </div>
                    </div>
                    <div class="grid grid-cols-1 md:grid-cols-4 gap-2 mt-4">
                        <button class="hover:cursor-pointer inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide 
                                            transition duration-300 border rounded-full focus-visible:outline-none whitespace-nowrap bg-black/50 border-green-500 
                                            text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 
                                            disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none
                                            mx-4 uppercase transform hover:scale-105" (click)="navigateToId('sostenibilidad')">
                            <span>{{texts.buttons[0]}}</span>
                        </button>
                        <button class="hover:cursor-pointer inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide 
                                            transition duration-300 border rounded-full focus-visible:outline-none whitespace-nowrap bg-black/50 border-green-500 
                                            text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 
                                            disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none
                                            mx-4 uppercase transform hover:scale-105" (click)="navigateToId('fabricacion')">
                            <span>{{texts.buttons[1]}}</span>
                        </button>
                        
                        <button class="hover:cursor-pointer inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide 
                                            transition duration-300 border rounded-full focus-visible:outline-none whitespace-nowrap bg-black/50 border-green-500 
                                            text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 
                                            disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none
                                            mx-4 uppercase transform hover:scale-105" (click)="navigateToId('hitos')">
                            <span>{{texts.buttons[2]}}</span>
                        </button>
                        <button class="hover:cursor-pointer inline-flex items-center justify-center h-8 gap-2 px-4 text-xs font-medium tracking-wide 
                                            transition duration-300 border rounded-full focus-visible:outline-none whitespace-nowrap bg-black/50 border-green-500 
                                            text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 
                                            disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none
                                            mx-4 uppercase transform hover:scale-105" (click)="navigateToId('empresa')">
                            <span>{{texts.buttons[3]}}</span>
                        </button>
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div >
        <section class="bg-black py-16">
            <div class="max-w-5xl mx-auto px-6">
                <div class="aspect-video rounded-lg flex items-center justify-center">
                    <div class="text-center">
                        <div class="w-full h-auto rounded-full flex items-center justify-center mx-auto mb-4">
                            <iframe class="aspect-video items-center mx-auto w-xs md:w-2xl lg:w-4xl h-auto" src="https://www.youtube.com/embed/8VHH211-5jY?si=zGrUOSeBShqND6-Q" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</section>

    

    <!-- Video Section -->
    

    <!-- Stats Section -->
    <section class="bg-black py-16" id="sostenibilidad">
        <div class="max-w-4xl mx-auto px-6">
            <div class="text-center mb-16">
                <h2 class="text-3xl font-bold mb-4">
                    {{texts.compromisos.title}}
                </h2>
            </div>
            <!-- <div class="grid md:grid-cols-4 gap-8 text-center">
                <div>
                    <div class="text-white text-2xl font-bold mb-2">PROYECTOS</div>
                    <div class="text-green-600 text-3xl font-bold">80%</div>
                    
                </div>
                <div>
                    <div class="text-white text-2xl font-bold mb-2">PRODUCTOS</div>
                    <div class="text-green-600 text-3xl font-bold">1,025+</div>
                </div>
                <div>
                    <div class="text-white text-2xl font-bold mb-2">PRESENCIA</div>
                    <div class="text-green-600 text-3xl font-bold">169</div>
                </div>
                <div>
                    <div class="text-white text-2xl font-bold mb-2">PATENTES AUTORIZADOS</div>
                    <div class="text-green-600 text-3xl font-bold">330</div>
                </div>
            </div> -->
            <div class="text-center mt-8">
                <p class="text-gray-300 text-lg mb-4">
                    {{texts.compromisos.description[0]}}
                </p>
                <p class="text-gray-300 text-lg mb-4">
                    {{texts.compromisos.description[1]}}
                </p>

                <!-- <a href="https://www.prinxtire.eu/excellence/esg-report-2022" target="_blank" rel="noopener noreferrer">
                    <button class="inline-flex items-center justify-center h-8 gap-2 my-6 px-10 text-xs font-medium tracking-wide 
                                            transition duration-300 border rounded-full focus-visible:outline-none whitespace-nowrap bg-black/50 border-green-500 
                                            text-green-500 hover:border-green-600 hover:text-green-600 focus:border-green-700 focus:text-green-700 
                                            disabled:cursor-not-allowed disabled:border-green-300 disabled:text-green-300 disabled:shadow-none
                                            mx-4 hover:cursor-pointer transform hover:scale-105">
                        <span>Informe ESG</span>
                    </button>
                </a> -->
                
            </div>
        </div>
        <div>
            <img src="src/assets/img/about_us/658417b75e1ccb9abd5f7cce_grid.webp" class="w-full h-auto" alt="" srcset="">
        </div>
    </section>

    <!-- Tire Portfolio Section -->
    <!-- <section class="bg-white text-gray-900 py-16">
        <div class="max-w-4xl mx-auto px-6">
            <h2 class="text-4xl lg:text-7xl font-bold text-center mb-12 uppercase">
                Cartera de<br>llantas
            </h2>
            <div class="flex items-center justify-center mx-auto">
                <img src="/assets/img/about_us/tire-list.png" class="w-full" alt="tire-list" srcset="">
                
            </div>
        </div>
    </section> -->

    <!-- Manufacturing Section -->
    <section class="bg-black py-16" id="fabricacion">
        <div class="max-w-4xl mx-auto px-6 text-center">
            <h2 class="text-3xl font-bold mb-4">
                {{texts.valores.title}}
            </h2>
            <p class="text-gray-300 mb-6 leading-relaxed text-lg">
                {{texts.valores.description}}
            </p>
            <div class="">
                <ul>
                    <li class="my-1">
                       - <span class="font-semibold text-lg">{{texts.valores.list[0].title}}:</span> {{texts.valores.list[0].information}}
                    </li>
                    <li class="my-1">
                       - <span class="font-semibold text-lg">{{texts.valores.list[1].title}}:</span> {{texts.valores.list[1].information}}
                    </li>
                    <li class="my-1">
                       - <span class="font-semibold text-lg">{{texts.valores.list[2].title}}:</span> {{texts.valores.list[2].information}}
                    </li>
                    <li class="my-1">
                       - <span class="font-semibold text-lg">{{texts.valores.list[3].title}}:</span> {{texts.valores.list[3].information}}
                    </li>
                    <li class="my-1">
                       - <span class="font-semibold text-lg">{{texts.valores.list[4].title}}:</span> {{texts.valores.list[4].information}}
                    </li>
                </ul>
            </div>
        </div>
    </section>

    <!-- Timeline Section -->
    <section class="bg-black py-16" id="hitos">
        <!-- <div class="max-w-4xl mx-auto px-6 grid md:grid-cols-2 gap-4">
            <div>
                <h2 class="text-3xl font-bold mb-6">HITOS</h2>
                <div class="mb-8">25 AÑOS DE LOGROS</div>
                
                <div class="space-y-8">
                    <div class="items-start space-x-4">
                        <p class="font-semibold">2005</p>
                        <p class="text-gray-300 text-sm">
                            Establecemos nuestra sede regional para desarrollar la empresa en el continente americano.
                        </p>
                    </div>
                    
                    <div class="items-start space-x-4">
                        <p class="font-semibold">2005</p>
                        <p class="text-gray-300 text-sm">
                            Lanzamos una gama de artículos "Green Friendly" que el Ministerio de Industria y Tecnología ha declarado como productos verdes.
                        </p>
                    </div>
                    
                    <div class="items-start space-x-4">
                        <p class="font-semibold">2005</p>
                        <p class="text-gray-300 text-sm">
                            Desarrollamos la metodología y sistema en alianza el Laboratorio de Ensayo Orgánico (MAT).
                        </p>
                    </div>
                    
                    <div class="items-start space-x-4">
                        <p class="font-semibold">2005</p>
                        <p class="text-gray-300 text-sm">
                            Reafirmamos nuestra visión en Energías Sostenibles y eficiencia para reducir nuestros gases de efecto invernadero alrededor de toda nuestra operación industrial y logística.
                        </p>
                    </div>
                    
                    <div class="items-start space-x-4">
                        <p class="font-semibold">2005</p>
                        <p class="text-gray-300 text-sm">
                            Reafirmamos nuestro liderazgo en el mercado para expandir nuestras operaciones latinoamericanas.
                        </p>
                    </div>
                </div>
            </div>
            
            <div class="flex items-center justify-center bg-no-repeat bg-cover bg-top relative" style="background-image: linear-gradient(90deg, #000, #0000), url(src/assets/img/about_us/lights_bg.png);  opacity: 1;transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);transform-style: preserve-3d;">
                <div class="absolute inset-0 bg-gradient-to-tr from-black/80 via-black/60 to-transparent"></div>
            </div>
        </div> -->

        <div class="max-w-4xl mx-auto px-6">
            <div class="text-center mb-6">
                <h2 class="text-3xl font-bold mb-4">
                    {{texts.que_ofrecemos.title}}
                </h2>
            </div>
            <div class="text-center mt-2">
                <p class="text-gray-300 text-lg mb-4">
                    {{texts.que_ofrecemos.description[0]}}
                </p>
                <p class="text-gray-300 text-lg mb-4">
                    {{texts.que_ofrecemos.description[1]}}
                </p>
                <p class="text-gray-300 text-lg mb-4">
                    {{texts.que_ofrecemos.description[2]}}
                </p>
            </div>
        </div>
    </section>

    <!-- Location Section -->
    <section class="bg-black py-16" id="empresa">
        <div class="max-w-4xl mx-auto px-6 items-center">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="md:col-span-2">
                    <div class="text-center mb-16">
                        <h2 class="text-3xl font-bold mb-4">
                            {{texts.empresa.title}}
                        </h2>
                    </div>
                    <div class="text-center mt-8">
                        <p class="text-gray-300 text-lg mb-4">
                            {{texts.empresa.description[0]}}
                        </p>
                        <p class="text-gray-300 text-lg mb-4">
                            {{texts.empresa.description[1]}}
                        </p>
                    </div>
                </div>

                <div class="w-full h-64 rounded-lg overflow-hidden">
                    <img src="src/assets/img/about_us/cr_office.png" class="w-full" alt="" srcset="">
                </div>

                <div class="pl-6">
                    <h3 class="text-2xl font-bold mb-4">{{texts.ubicacion.title}}</h3>
                    <div class="text-green-400 font-bold mb-2">Mundo EV</div>
                    <address class="text-gray-300 text-sm not-italic">

                        San José, Costa Rica<br>
                    </address>
                    <p class="text-green-500">
                        <a href="mailto:info@prinxcr.com">
                            info&#64;prinxcr.com
                        </a>
                    </p>
                    <p class="text-green-500"><a href="tel:+50688979888">+506 88979888</a></p>
                    <!-- <p class="text-green-500">
                        <a href="tel:8888-8888">
                        8888-8888
                        </a>
                    </p> -->
                    
                </div>
            </div>
            
        </div>
    </section>
    <section class="bg-black py-16">
        <div class="max-w-6xl mx-auto">
            <app-partners-carrousel/>

        </div>
    </section>

<app-footer></app-footer>